module.exports = __webpack_public_path__ + "img/green-success-circle.52fe5261.svg";